var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabelaAdicionaTrajeto',{attrs:{"payload":_vm.roteiro.trajetos,"isListagem":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }